// Convierte el valor de un data-attribute replicando la coerción de jQuery .data()
// ("true"/"false" -> boolean, numérico -> number, resto -> string).
const parseDataValue = (val) => {
  if (val == null) return undefined;
  if (val === 'true') return true;
  if (val === 'false') return false;
  if (val === 'null') return null;
  if (val !== '' && !isNaN(val) && !isNaN(parseFloat(val))) return +val;
  return val;
};

// Animaciones de despliegue equivalentes a jQuery slideDown/slideUp (vanilla, sin dependencias).
const slideDown = (el, duration = 400) => {
  el.style.removeProperty('display');
  let display = window.getComputedStyle(el).display;
  if (display === 'none') display = 'block';
  el.style.display = display;
  const height = el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight; // forzar reflow
  el.style.boxSizing = 'border-box';
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  el.style.removeProperty('margin-top');
  el.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
    el.style.removeProperty('box-sizing');
  }, duration);
};

const slideUp = (el, duration = 400) => {
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.boxSizing = 'border-box';
  el.style.height = el.offsetHeight + 'px';
  el.offsetHeight; // forzar reflow
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  window.setTimeout(() => {
    el.style.display = 'none';
    el.style.removeProperty('height');
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
    el.style.removeProperty('box-sizing');
  }, duration);
};

const initSwipers = () => {
  if (!window.Swiper) {
    return;
  }

  const containers = document.querySelectorAll('.swiper-container');
  if (!containers.length) {
    return;
  }

  const swiperInstances = [];

  containers.forEach((el, index) => {
    const uniqueClass = `swiper-slider-${index}`;
    el.classList.add(uniqueClass);

    const data = (key) => parseDataValue(el.dataset[key]);

    const dragSize = data('dragSize') || 50;
    const freeMode = data('freeMode') || false;
    const loop = data('loop') || false;
    const slidesDesktop = data('slidesDesktop') || 4;
    const slidesTablet = data('slidesTablet') || 3;
    const slidesMobile = data('slidesMobile') || 1.5;
    const spaceBetween = data('spaceBetween') || 60;
    const autoPlay = data('autoPlay') ? true : false;

    // Assign unique elements inside each swiper container
    const paginationEl = el.querySelector('.swiper-pagination');
    const scrollbarEl = el.querySelector('.swiper-scrollbar');
    const nextEl = el.querySelector('.swiper-button-next');
    const prevEl = el.querySelector('.swiper-button-prev');

    const swiper = new Swiper(`.${uniqueClass}`, {
      direction: 'horizontal',
      loop: loop,
      freeMode: freeMode,
      spaceBetween: spaceBetween,
      ...(autoPlay && {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
      }),
      breakpoints: {
        1280: { slidesPerView: slidesDesktop },
        767: { slidesPerView: slidesTablet, spaceBetween: 30 },
        320: { slidesPerView: slidesMobile, spaceBetween: 30 },
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        dragSize: dragSize,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
        dynamicBullets: true,
      },
    });

    swiperInstances.push(swiper);
  });

  document.querySelectorAll('.nav-tabs a').forEach((link) => {
    link.addEventListener('click', () => {
      swiperInstances.forEach((swiper) => swiper.update());
    });
  });
};

// Button Hover Effect (Handled via CSS for better performance)



const initFaqs = () => {
  const questions = document.querySelectorAll('.faq-question');
  if (!questions.length) {
    return;
  }

  questions.forEach((question) => {
    question.addEventListener('click', function () {
      const item = question.closest('.faq-item');
      if (!item) {
        return;
      }
      const answer = item.querySelector('.faq-answer');
      const willOpen = !item.classList.contains('active');

      document.querySelectorAll('.faq-item').forEach((other) => {
        if (other === item) {
          return;
        }
        other.classList.remove('active');
        const otherQuestion = other.querySelector('.faq-question');
        const otherAnswer = other.querySelector('.faq-answer');
        if (otherQuestion) {
          otherQuestion.setAttribute('aria-expanded', 'false');
        }
        if (otherAnswer) {
          otherAnswer.setAttribute('aria-hidden', 'true');
          slideUp(otherAnswer);
        }
      });

      if (willOpen) {
        item.classList.add('active');
        question.setAttribute('aria-expanded', 'true');
        if (answer) {
          answer.setAttribute('aria-hidden', 'false');
          slideDown(answer);
        }
      } else {
        item.classList.remove('active');
        question.setAttribute('aria-expanded', 'false');
        if (answer) {
          answer.setAttribute('aria-hidden', 'true');
          slideUp(answer);
        }
      }
    });
  });
};

// Tabs equivalentes a Bootstrap (data-bs-toggle="tab") en vanilla, sin el bundle de Bootstrap.
// Mantiene las clases .active / .show y la accesibilidad (aria-selected) que ya usa el CSS de Bootstrap.
const initTabs = () => {
  const tabLinks = document.querySelectorAll('[data-bs-toggle="tab"]');
  if (!tabLinks.length) {
    return;
  }

  tabLinks.forEach((link) => {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      const selector = link.getAttribute('data-bs-target') || link.getAttribute('href');
      if (!selector || selector === '#') {
        return;
      }
      const pane = document.querySelector(selector);
      if (!pane) {
        return;
      }

      // Acotar al grupo de tabs (lista) y al contenedor de paneles correspondiente.
      const tablist = link.closest('.nav, .nav-tabs, [role="tablist"]');
      const content = pane.closest('.tab-content');

      if (tablist) {
        tablist.querySelectorAll('[data-bs-toggle="tab"]').forEach((other) => {
          other.classList.remove('active');
          other.setAttribute('aria-selected', 'false');
        });
      }
      if (content) {
        content.querySelectorAll(':scope > .tab-pane').forEach((other) => {
          other.classList.remove('show', 'active');
        });
      }

      link.classList.add('active');
      link.setAttribute('aria-selected', 'true');
      pane.classList.add('active');
      pane.offsetHeight; // reflow para que el fade de opacidad se anime
      pane.classList.add('show');
    });
  });
};

const initActiveButtonGroup = (selector) => {
  const buttons = document.querySelectorAll(selector);
  if (!buttons.length) {
    return;
  }
  buttons.forEach((button) => {
    button.addEventListener('click', function () {
      buttons.forEach((btn) => btn.classList.remove('active'));
      this.classList.add('active');
    });
  });
};

const initDropdownHover = () => {
  if (!window.matchMedia('(min-width: 993px)').matches) {
    return;
  }

  const dropdowns = document.querySelectorAll('.nav-item.dropdown');

  dropdowns.forEach((dropdown) => {
    let timer;
    const menu = dropdown.querySelector('.dropdown-menu');
    if (!menu) {
      return;
    }

    dropdown.addEventListener('mouseenter', () => {
      clearTimeout(timer);
      dropdown.classList.add('show');
      menu.classList.add('show');
    });

    dropdown.addEventListener('mouseleave', () => {
      timer = setTimeout(() => {
        dropdown.classList.remove('show');
        menu.classList.remove('show');
      }, 150);
    });
  });
};

document.addEventListener('DOMContentLoaded', function () {
  initSwipers();
  initFaqs();
  initTabs();
  initActiveButtonGroup('.series-button');
  initActiveButtonGroup('.size-button');
  initDropdownHover();
});


const parsePriceRange = (priceRange) =>
  priceRange.split('-').map((value) => value.trim().replace('$', ''));

document.body.addEventListener('click', function (event) {
  // Check if the clicked element is a checkbox within the custom-price-filter-ul
  if (event.target.matches('.custom-price-filter-ul input[type="checkbox"]')) {
    const input = event.target;

    // Get references to the GTE and LTE inputs
    const gteInput = document.getElementById('Filter-Price-GTE');
    const lteInput = document.getElementById('Filter-Price-LTE');
    if (!gteInput || !lteInput) {
      return;
    }

    if (input.checked) {
      // If the checkbox is checked, update the values
      const priceRange = input.dataset.priceRange;
      const [gte, lte] = parsePriceRange(priceRange);
      gteInput.value = gte || '';
      lteInput.value = lte || '';
    } else {
      // If the checkbox is unchecked, check if any other checkboxes are still checked
      const checkedCheckboxes = document.querySelectorAll('.custom-price-filter-ul input[type="checkbox"]:checked');

      if (checkedCheckboxes.length > 0) {
        // Get the price range of the first checked checkbox
        const firstChecked = checkedCheckboxes[0];
        const priceRange = firstChecked.dataset.priceRange;
        const [gte, lte] = parsePriceRange(priceRange);
        gteInput.value = gte || '';
        lteInput.value = lte || '';
      } else {
        // If no checkboxes are checked, clear the input values
        gteInput.value = '';
        lteInput.value = '';
      }
    }
  }
});




// document.querySelectorAll('.nav-item.dropdown > a').forEach(function(anchor) {
//   anchor.addEventListener('click', function(event) {
//     event.preventDefault(); // Prevent the default behavior

//     const dropdown = anchor.closest('.nav-item.dropdown');
//     const dropdownMenu = dropdown.querySelector('.dropdown-menu');
//     const caretIcon = dropdown.querySelector('.icon-caret');

//     // Close all other dropdowns
//     document.querySelectorAll('.section-header .nav-item.dropdown').forEach(function(otherDropdown) {
//       const otherDropdownMenu = otherDropdown.querySelector('.dropdown-menu');
//       const otherCaretIcon = otherDropdown.querySelector('.icon-caret');

//       // Close the other dropdowns and reset their icons
//       if (otherDropdownMenu !== dropdownMenu) {
//         otherDropdownMenu.classList.remove('show1');
//         otherCaretIcon.classList.remove('rotated');
//       }
//     });

//     // Toggle the dropdown menu and caret icon
//     dropdownMenu.classList.toggle('show1');
//     caretIcon.classList.toggle('rotated');
//   });
// });


// Detect when the page is scrolled past the header
let isStickyScrollTicking = false;
window.addEventListener('scroll', function () {
  if (isStickyScrollTicking) {
    return;
  }

  isStickyScrollTicking = true;
  requestAnimationFrame(() => {
    const navbarCollapse = document.querySelector('.navbar-collapse');
    const header = document.querySelector('.page-width');

    // Check if elements exist before accessing properties
    if (header && navbarCollapse) {
      // Check if the header has reached the sticky state
      if (window.scrollY > header.offsetHeight) {
        // If the header is sticky, change the `top` value for navbar-collapse
        navbarCollapse.classList.add('sticky-header');
      } else {
        // If the header is not sticky, reset the `top` value for navbar-collapse
        navbarCollapse.classList.remove('sticky-header');
      }
    }

    isStickyScrollTicking = false;
  });
}, { passive: true });


// Select all anchor tags within the #navbarNav element
document.querySelectorAll('#navbarNav a').forEach(anchor => {
  // Check if the href attribute contains '%3F'
  if (anchor.href.includes('%3F')) {
    // Replace '%3F' with '?'
    anchor.href = anchor.href.replace('%3F', '?');
  }
});


/******* SMOOTH SCROLLING ***********/
// document.querySelectorAll('.scroll-link').forEach(link => {
//   link.addEventListener('click', function(e) {
//     e.preventDefault(); // Prevent default anchor behavior
//     const target = document.querySelector(this.getAttribute('href')); // Get the target element
//     const headerOffset = 80; // Adjust this value according to the header height or any fixed element
//     const elementPosition = target.getBoundingClientRect().top; // Get the position of the target
//     const offsetPosition = elementPosition + window.pageYOffset - headerOffset; // Adjust by the header offset

//     window.scrollTo({
//       top: offsetPosition,
//       behavior: 'smooth'
//     });
//   });
// });


function normalizeColorToken(color) {
  return color?.toLowerCase().trim().replace(/\s+/g, '-');
}

function filterImagesByColor() {
  // Get the checked radio button's value
  const selectedColor = normalizeColorToken(document.querySelector('.color-options input[name="color"]:checked')?.value);

  // Get all images in the swiper slider
  const swiperImages = document.querySelectorAll('.swiper-slide img');

  // Variable to track if any image matches the selected color
  let matchFound = false;

  if (selectedColor) {
    // Loop through all images and check the data-color attribute
    swiperImages.forEach(image => {
      const imageColors = (image.dataset.colorList || image.dataset.color || '')
        .split(/[\|,\/]/)
        .map(normalizeColorToken)
        .filter(Boolean);

      if (imageColors.includes(selectedColor) || imageColors.includes('all-show') || imageColors.includes('all')) {
        // Show images that match the selected color or are generic
        image.closest('.swiper-slide').style.display = '';
        matchFound = true;
      } else {
        // Hide images that don't match
        image.closest('.swiper-slide').style.display = 'none';
      }
    });

    // If no match is found, show all images (fallback)
    if (!matchFound) {
      swiperImages.forEach(image => {
        image.closest('.swiper-slide').style.display = '';
      });
    }
  } else {
    // If no color is selected, show all images
    swiperImages.forEach(image => {
      image.closest('.swiper-slide').style.display = '';
    });
  }

  // Notify Swiper instances to update
  document.dispatchEvent(new CustomEvent('media:filtered'));
}

// Initial call on page load
document.addEventListener('DOMContentLoaded', filterImagesByColor);

// Reapply the logic after AJAX content is loaded
document.body.addEventListener('ajaxComplete', filterImagesByColor);

// Optionally handle dynamic user interactions (e.g., radio button changes)
document.body.addEventListener('change', (event) => {
  if (event.target.matches('.color-options input[name="color"]')) {
    document.getElementById('loader').style.display = 'block';
    filterImagesByColor();
    setTimeout(function () {
      document.getElementById('loader').style.display = 'none';
    }, 500);

  }
});

document.addEventListener('DOMContentLoaded', () => {
  const currentUrl = window.location.pathname;
  const filterButtons = document.querySelectorAll('.product-types-filter-buttons a');

  filterButtons.forEach(button => {
    button.classList.remove('active'); // Remove active class from all buttons

    if (button.getAttribute('href') === currentUrl) {
      button.classList.add('active'); // Add active class to the matching button
    }
  });
});
